import axios from 'axios';
import { authService } from './authService';
import resolveBaseURL from './apiBase';

// Configuração base da API
const api = axios.create({
  baseURL: resolveBaseURL(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token de autenticação
api.interceptors.request.use(
  (config: any) => {
    const token = authService.getToken();
    const tokenType = authService.getTokenType();
    
    // Verificar se o token expirou
    if (authService.isTokenExpired()) {
      authService.logout();
      window.location.href = '/login';
      return Promise.reject(new Error('Token expirado'));
    }
    
    if (token) {
      // Usar o tipo de token retornado pela API (geralmente "Bearer")
      const authHeader = tokenType ? `${tokenType} ${token}` : `Bearer ${token}`;
      config.headers.Authorization = authHeader;
      
      // Adicionar tenantId se disponível
      const tenantId = authService.getTenantId();
      if (tenantId) {
        config.headers['X-Tenant-ID'] = tenantId;
      }

      // Adicionar empresaId (companyId) se disponível
      const companyId = authService.getCompanyId();
      if (companyId) {
        // Backend exige header "X-Empresa-Id"
        config.headers['X-Empresa-Id'] = companyId;
      }
    }
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar respostas e erros
api.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error: any) => {
    if (error.response?.status === 401) {
      // Token expirado ou inválido - usar authService para logout completo
      authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;